var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "formValidation",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ pristine, invalid }) {
          return [
            _c(
              "form",
              {
                staticClass: "form-register-mfa",
                class: { "login-flow": _vm.isLoginFlow },
                attrs: { role: "form" }
              },
              [
                _vm.isLoginFlow
                  ? _c("h2", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "PAGE_TITLE",
                          expression: "'PAGE_TITLE'"
                        }
                      ],
                      staticClass: "m-b-15"
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "bs-callout bs-callout-sm bs-callout-primary"
                  },
                  [
                    _vm.isLoginFlow
                      ? _c("span", [_vm._v(_vm._s(_vm.loginFlowMessage))])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("i18n", {
                      attrs: { path: "NOTE_AUTH_APP_REQUIRED", tag: "span" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "link",
                            fn: function() {
                              return [
                                _c(
                                  "a",
                                  {
                                    staticClass: "home_link",
                                    attrs: {
                                      href:
                                        "https://support.ringba.com/hc/en-us/articles/26643696732951-Multi-Factor-Authentication",
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t("NOTE_AUTH_APP_REQUIRED_LINK")
                                        ) +
                                        "\n            "
                                    ),
                                    _c("i", {
                                      staticClass: "fa fa-external-link m-l-1"
                                    })
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-12 col-md-6" }, [
                  _c("h3", {
                    staticClass: "m-b-10",
                    domProps: {
                      textContent: _vm._s(_vm.$t("SCAN_THIS_QRCODE_TITLE"))
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm.isLoadingSettings
                      ? _c(
                          "div",
                          { staticClass: "m-b-15 m-t-15" },
                          [
                            _c("Loader"),
                            _vm._v(" "),
                            _c("span", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "LOADING_QR_CODE",
                                  expression: "'LOADING_QR_CODE'"
                                }
                              ]
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isLoadingSettings
                      ? _c("div", { staticClass: "qr-code" }, [
                          _c("img", {
                            staticStyle: { width: "100%" },
                            attrs: { src: _vm.qrCodeImageSource, alt: "" }
                          })
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-b-15" }, [
                    _c("span", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SCAN_THIS_QRCODE_DESCRIPTION.NO_CAMERA_INSTRUCTION"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "SCAN_THIS_QRCODE_DESCRIPTION.ENTER_CODE_APP"
                            )
                          ) +
                          "\n          "
                      ),
                      _c("br")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "clickable",
                        on: { click: _vm.onCopySecretClick }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.mfaSettings.secretKey) +
                            " "
                        ),
                        _c("i", { staticClass: "fa fa-copy" })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-12 col-md-6" },
                  [
                    _c("h3", {
                      staticClass: "m-b-10",
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t("ENTER_VALIDATION_DIGITS_TITLE")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("VALIDATION_CODE"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("VALIDATION_CODE_TOOLTIP")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function() {
                              return [
                                _c(
                                  "ValidationProvider",
                                  { attrs: { rules: "required", slim: "" } },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.sixDigitsValidation,
                                          expression: "sixDigitsValidation"
                                        }
                                      ],
                                      ref: "validationInput",
                                      staticClass:
                                        "form-control r-form__input width-auto p-10",
                                      class: {
                                        error: _vm.enableMFAStatus.error
                                      },
                                      attrs: {
                                        type: "text",
                                        autocomplete: "one-time-code",
                                        inputmode: "numeric",
                                        required: "true"
                                      },
                                      domProps: {
                                        value: _vm.sixDigitsValidation
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.sixDigitsValidation =
                                            $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "validation-error" },
                                      [
                                        _vm.enableMFAStatus.error
                                          ? _c(
                                              "span",
                                              { staticClass: "text-danger" },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.enableMFAStatus.error
                                                    ) +
                                                    "\n              "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "PrimaryButton",
                      {
                        attrs: {
                          size: "sm",
                          disabled: pristine || invalid,
                          "show-loader-on-form":
                            _vm.enableMFAStatus.status === "pending"
                        },
                        on: { click: _vm.onEnableMFA }
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.$t("ENABLE")) + "\n      "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.isLoginFlow
                      ? _c("button", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CANCEL",
                              expression: "'CANCEL'"
                            }
                          ],
                          staticClass: "btn btn-sm btn-danger m-l-15",
                          on: { click: _vm.hideDetailsForm }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isLoginFlow && !_vm.enforceMfa
                      ? _c("p", { staticClass: "m-t-15 m-b-15" }, [
                          _c("span", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "SKIP_THIS_TIME",
                                expression: "'SKIP_THIS_TIME'"
                              }
                            ],
                            staticClass: "clickable",
                            attrs: { "data-testid": "skip-mfa-button" },
                            on: { click: _vm.skipMFA }
                          })
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }